import React from 'react';
import 'twin.macro';
import Select from 'components/Form/Select2';
import { Classroom } from 'types/classroom';
import { ROSelect } from 'containers/Eleves/List/Table/Cells/components/ROSelect';

interface Props {
  value: string;
  onChange: (v: string) => void;
  classrooms: Classroom[];
  readonly?: boolean;
}

export function ClassroomCell(props: Props) {
  const { onChange, value, classrooms, readonly } = props;
  const [classroomId, setClassroomId] = React.useState<string>(value);
  const [editing, setEditing] = React.useState<boolean>(false);

  const matchingClassroom = classrooms.find(c => c.id === classroomId);
  if (readonly) {
    return <div>{matchingClassroom?.name}</div>;
  }

  if (!editing) {
    return (
      <div tw="max-w-20">
        <ROSelect onClick={() => setEditing(true)}>
          {matchingClassroom?.name}
        </ROSelect>
      </div>
    );
  }
  return (
    <div tw="min-w-[5rem]">
      <Select<string>
        withoutCheck
        portal
        openOnMount
        tw="hover:bg-transparent hover:border-opacity-100 px-1"
        withoutChevron
        value={classroomId}
        onClickOutside={() => {
          setEditing(false);
        }}
        onChange={v => {
          if (v !== classroomId || v !== value) {
            setClassroomId(v);
            onChange(v);
            setEditing(false);
          }
        }}
        options={classrooms.map(c => ({ value: c.id, label: c.name }))}
      />
    </div>
  );
}
